import { SelectOptionType } from "@/components";

export enum YES_NO {
  YES = "Yes",
  NO = "No",
}
export enum DATA_SOURCE_TYPE {
  AIDC = "AIDC",
  DATA_UPLOAD = "Data Upload",
}
export const optionsDataSource = [
  {
    label: "Data Upload",
    value: "Data Upload",
  },
  {
    label: "AIDC",
    value: "AIDC",
  },
];
export const optionsRepeat = [
  {
    label: "No",
    value: "false",
    other: false,
  },
  {
    label: "Yes",
    value: "true",
    other: true,
  },
];
export const optionsRepeatEvery = [
  {
    label: "Daily",
    value: "Daily",
  },
  {
    label: "Weekly",
    value: "Weekly",
  },
  {
    label: "Monthly",
    value: "Monthly",
  },
];
// for channel parameters
export enum CHANNEL {
  SMS = "SMS",
  WHATSAPP = "Whatsapp",
  FIELD = "Field",
}
export const optionsChannel = [
  {
    label: "SMS",
    value: "SMS",
    disabled: false,
  },
  {
    label: "Whatsapp",
    value: "Whatsapp",
    disabled: false,
  },
  {
    label: "Email",
    value: "Email",
    disabled: true,
  },
  {
    label: "Viber",
    value: "Viber",
    disabled: true,
  },
  // if dae2 is enabled, field will enable
  {
    label: "Field",
    value: "Field",
    disabled: import.meta.env.VITE_ENABLED_DAE2 !== "true",
  },
];
export const optionsTriggerBy = [
  {
    label: "Date",
    value: "Date",
  },
];
export const optionsCondition = [
  {
    label: "Loan Due Date",
    value: "Loan Due Date",
  },
  {
    label: "Birthday",
    value: "Birthday",
  },
  {
    label: "Anniversary",
    value: "Anniversary",
  },
];

export const fieldCategories = {
  Date: [
    { label: "Loan Due Date", value: "Loan Due Date" },
    { label: "Birthday", value: "Birthday" },
    { label: "Anniversary", value: "Anniversary" },
  ],
  Numeric: [
    { label: "Loan Amount", value: "Loan Amount" },
    { label: "PTP Amount", value: "PTP Amount" },
  ],
  String: [{ label: "Loan Agreement", value: "Loan Agreement" }],
  List: [
    { 
      label: "List Value - Equals",
      value: "List Value - Equals",
    },
  ],
};

export enum ACTION {
  BEFORE_DATE = "Before Date",
  ON_DATE = "On Date",
  AFTER_DATE = "After Date",
}
export const optionsAction = [
  {
    label: "Before Date",
    value: "Before Date",
  },
  {
    label: "On Date",
    value: "On Date",
  },
  {
    label: "After Date",
    value: "After Date",
  },
];
export enum SCHEDULE_MODE {
  NUMBER_OF_DAYS = "Number of days",
  SPECIFIC_DATE = "Specific date",
}
export enum MAIN_OPERATOR {
  AND = "AND",
  OR = "OR",
}
export const optionsScheduleMode = [
  {
    label: "Number of Days",
    value: "Number of days",
  },
  {
    label: "Specific Day",
    value: "Specific date",
  },
];
// for specific day mode = specific day
export const optionsSpecificDay = [
  {
    label: "",
    value: "all",
    other: {
      label: "All Day",
    },
  },
  {
    label: "Monday",
    value: "Monday",
  },
  {
    label: "Tuesday",
    value: "Tuesday",
  },
  {
    label: "Wednesday",
    value: "Wednesday",
  },
  {
    label: "Thursday",
    value: "Thursday",
  },
  {
    label: "Friday",
    value: "Friday",
  },
  {
    label: "Saturday",
    value: "Saturday",
  },
  {
    label: "Sunday",
    value: "Sunday",
  },
];
export const optionsTimeBand = [
  {
    label: "",
    value: "all",
    other: {
      label: "All Time Bands",
    },
  },
  {
    label: "8am - 10am",
    value: "8am - 10am",
  },
  {
    label: "10am - 12am",
    value: "10am - 12am",
  },
  {
    label: "12pm - 2pm",
    value: "12pm - 2pm",
  },
  {
    label: "2pm - 4pm",
    value: "2pm - 4pm",
  },
  {
    label: "4pm - 6pm",
    value: "4pm - 6pm",
  },
  {
    label: "6pm - 8pm",
    value: "6pm - 8pm",
  },
];
// for customer parameters
export const OCCUPATIONS = [
  "All Occupations",
  "Salaried",
  "Self Employed",
  "Others",
];
export const AGE_BANDS = [
  "All Age Bands",
  "18-25",
  "26-35",
  "36-45",
  "46-55",
  "56-65",
  "> 65",
];
export const CUSTOMER_RISK_PROFILE = [
  "All Risk Profiles",
  "Low Risk",
  "Medium Risk",
  "High Risk",
];
export const CHANNEL_PROPENSITY = [
  "AI Based Recommendation",
  "SMS",
  "Email",
  "Viber",
  "Facebook",
  "IVR",
  "Whatsapp",
];
export const PROPENSITY_TO_PAY = ["Low Risk", "Medium Risk", "High Risk"];
export const PAID_LAST_3_MONTH = ["YES", "NO"];
export const ONLINE_PAID_EVER = ["YES", "NO"];
export const CURRENT_MONTH_BOUNCE = ["YES", "NO"];
export const optionsOccupation = [
  {
    label: "",
    value: "all",
    other: {
      label: "All Occupations",
    },
  },
  {
    label: "Salaried",
    value: "Salaried",
  },
  {
    label: "Self Employed",
    value: "Self Employed",
  },
  {
    label: "Others",
    value: "Others",
  },
];
export const optionsAgeBand = [
  {
    label: "",
    value: "all",
    other: {
      label: "All Age Bands",
    },
  },
  {
    label: "18-25",
    value: "18-25",
  },
  {
    label: "26-35",
    value: "26-35",
  },
  {
    label: "36-45",
    value: "36-45",
  },
  {
    label: "46-55",
    value: "46-55",
  },
  {
    label: "56-65",
    value: "56-65",
  },
  {
    label: "> 65",
    value: "> 65",
  },
];
export const optionsCustomerRiskProfile = [
  {
    label: "",
    value: "all",
    other: {
      label: "All Customer Risk Profiles",
    },
  },
  {
    label: "Low Risk",
    value: "Low Risk",
  },
  {
    label: "Medium Risk",
    value: "Medium Risk",
  },
  {
    label: "High Risk",
    value: "High Risk",
  },
];
export const optionsChannelPropensity = [
  {
    label: "",
    value: "all",
    other: {
      label: "All Based Propensity",
    },
  },
  {
    label: "SMS",
    value: "SMS",
  },
  {
    label: "Email",
    value: "Email",
  },
  {
    label: "Viber",
    value: "Viber",
  },
  {
    label: "IVR",
    value: "IVR",
  },
  {
    label: "Whatsapp",
    value: "Whatsapp",
  },
];
export const optionsPropensityToPay = [
  {
    label: "Low Risk",
    value: "Low Risk",
  },
  {
    label: "Medium Risk",
    value: "Medium Risk",
  },
  {
    label: "High Risk",
    value: "High Risk",
  },
];
export const optionsPaidLast3Month = [
  {
    label: YES_NO.YES,
    value: YES_NO.YES,
  },
  {
    label: YES_NO.NO,
    value: YES_NO.NO,
  },
];
export const optionsOnlinePaidEver = [
  {
    label: YES_NO.YES,
    value: YES_NO.YES,
  },
  {
    label: YES_NO.NO,
    value: YES_NO.NO,
  },
];
export const optionsCurrentMonthBounce = [
  {
    label: YES_NO.YES,
    value: YES_NO.YES,
  },
  {
    label: YES_NO.NO,
    value: YES_NO.NO,
  },
];
// for loan parameters
export const ACCOUNT_TYPES = [
  "All Account Types",
  "Live",
  "Matured",
  "Write off (NPA)",
  "Closure",
  "Foreclosed",
  "Sold Cases",
  "Seized",
];
export const MOBS = [
  "< 3 Months",
  "< 6 Months",
  "< 12 Months",
  "> 12 Months",
  "> 24 Months",
];
export const BUCKETS = [
  "All Bucket",
  "Bucket X",
  "Bucket 0",
  "Bucket 1",
  "Bucket 2",
  "Bucket 3",
  "Bucket 4",
  "Bucket 5",
  "Bucket >= 6",
];
export const OVERDUE_AMOUNT_BANDS = [
  "All Overdue Bands",
  "< 1000",
  "<= 25000",
  "> 25000",
];
export const VALUE_AT_RISKS = [
  "All Values At Risk",
  "< 1000",
  "<= 25000",
  "> 25000",
];
// First / Second / Third EMI
export const EMI = ["Yes", "No"];
export const PAYMENT_FREQUENCY = ["Quarterly", "Monthly", "Others"];

export const optionsAccountType = [
  {
    label: "",
    value: "all",
    other: {
      label: "All Account Types",
    },
  },
  {
    label: "Live",
    value: "Live",
  },
  {
    label: "Matured",
    value: "Matured",
  },
  {
    label: "Write off (NPA)",
    value: "Write off (NPA)",
  },
  {
    label: "Closure",
    value: "Closure",
  },
  {
    label: "Foreclosed",
    value: "Foreclosed",
  },
  {
    label: "Sold Cases",
    value: "Sold Cases",
  },
  {
    label: "Seized",
    value: "Seized",
  },
];
export const optionsMob = [
  {
    label: "< 3 Months",
    value: "< 3 Months",
  },
  {
    label: "< 6 Months",
    value: "< 6 Months",
  },
  {
    label: "< 12 Months",
    value: "< 12 Months",
  },
  {
    label: "> 12 Months",
    value: "> 12 Months",
  },
  {
    label: "> 24 Months",
    value: "> 24 Months",
  },
];
export const optionsBucket = [
  {
    label: "",
    value: "all",
    other: {
      label: "All Bucket",
    },
  },
  {
    label: "Bucket X",
    value: "Bucket X",
  },
  {
    label: "Bucket 0",
    value: "Bucket 0",
  },
  {
    label: "Bucket 1",
    value: "Bucket 1",
  },
  {
    label: "Bucket 2",
    value: "Bucket 2",
  },
  {
    label: "Bucket 3",
    value: "Bucket 3",
  },
  {
    label: "Bucket 4",
    value: "Bucket 4",
  },
  {
    label: "Bucket 5",
    value: "Bucket 5",
  },
  {
    label: "Bucket >= 6",
    value: "Bucket >= 6",
  },
];
export const optionsOverdueAmountBand = [
  {
    label: "",
    value: "all",
    other: {
      label: "All Overdue Bands",
    },
  },
  {
    label: "< 1000",
    value: "< 1000",
  },
  {
    label: "<= 25000",
    value: "<= 25000",
  },
  {
    label: "> 25000",
    value: "> 25000",
  },
];
export const optionsValueAtRisk = [
  {
    label: "",
    value: "all",
    other: {
      label: "All Values At Risk",
    },
  },
  {
    label: "< 1000",
    value: "< 1000",
  },
  {
    label: "<= 25000",
    value: "<= 25000",
  },
  {
    label: "> 25000",
    value: "> 25000",
  },
];
export const optionsFirstEmi = [
  {
    label: YES_NO.YES,
    value: YES_NO.YES,
  },
  {
    label: YES_NO.NO,
    value: YES_NO.NO,
  },
];
export const optionsSecondEmi = [
  {
    label: YES_NO.YES,
    value: YES_NO.YES,
  },
  {
    label: YES_NO.NO,
    value: YES_NO.NO,
  },
];
export const optionsThirdEmi = [
  {
    label: YES_NO.YES,
    value: YES_NO.YES,
  },
  {
    label: YES_NO.NO,
    value: YES_NO.NO,
  },
];
export const optionsPaymentFrequency = [
  {
    label: "Quarterly",
    value: "Quarterly",
  },
  {
    label: "Monthly",
    value: "Monthly",
  },
  {
    label: "Others",
    value: "Others",
  },
];

export const CAMPAIGN_TEXT_DETAIL = {
  STATUS: "Status",
  CAMPAIGN_ID: "Campaign ID",
  CREATED_BY: "Created By",
  CREATED_DATE: "Created Date",
};

export const CAMPAIGN_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  DRAFT: "DRAFT",
};

// for refer out
export const REFER_OUT_OPERATOR = {
  AND: "AND",
  OR: "OR",
};

export const optionsWhen: SelectOptionType[] = [
  {
    label: "Bucket",
    value: "Bucket",
  },
  {
    label: "Past Due Date",
    value: "Past Due Date",
  },
  {
    label: "Customer Risk Factor",
    value: "Customer Risk Factor",
  },
  {
    label: "Current Month Bounce",
    value: "Current Month Bounce",
  },
  {
    label: "Overdue Amount",
    value: "Overdue Amount",
  },
  {
    label: "MOB",
    value: "MOB",
  },
  {
    label: "First EMI",
    value: "First EMI",
  },
  {
    label: "Second EMI",
    value: "Second EMI",
  },
];

export const optionsMOBAction = [
  {
    label: "3 Months",
    value: "3 Months",
  },
  {
    label: "6 Months",
    value: "6 Months",
  },
  {
    label: "12 Months",
    value: "12 Months",
  },
  {
    label: "24 Months",
    value: "24 Months",
  },
];

export const NUMERIC_COMPARISON_OPTIONS: SelectOptionType[] = [
  {
    label: "Equals to",
    value: "Equals to",
  },
  {
    label: "Greater than",
    value: "Greater than",
  },
  {
    label: "Less than",
    value: "Less than",
  },
];

export const EQUALITY_COMPARISON_OPTIONS: SelectOptionType[] = [
  {
    label: "Equals to",
    value: "Equals to",
  },
];

export const PRIORITY_LEVEL_OPTIONS: SelectOptionType[] = [
  {
    label: "High",
    value: "High",
  },
  {
    label: "Medium",
    value: "Medium",
  },
  {
    label: "Low",
    value: "Low",
  },
];

export const BOOLEAN_CHOICE_OPTIONS: SelectOptionType[] = [
  {
    label: YES_NO.YES,
    value: YES_NO.YES,
  },
  {
    label: YES_NO.NO,
    value: YES_NO.NO,
  },
];

// [Field Allocation] Field Parameter
export const optionsCollectorGender = [
  {
    label: "All Gender",
    value: "All Gender",
  },
  {
    label: "Male",
    value: "Male",
  },
  {
    label: "Female",
    value: "Female",
  },
];

export const optionsCollectorSegment = [
  {
    label: "",
    value: "all",
    other: {
      label: "All Segment",
    },
  },
  {
    label: "In house",
    value: "In house",
  },
  {
    label: "GOS - GSO",
    value: "GOS - GSO",
  },
  {
    label: "Agency",
    value: "Agency",
  },
];

export const optionsPerformanceRating = [
  {
    label: "",
    value: "all",
    other: {
      label: "All Performance",
    },
  },
  {
    label: "Super",
    value: "Super",
  },
  {
    label: "Good",
    value: "Good",
  },
  {
    label: "Average",
    value: "Average",
  },
  {
    label: "Poor",
    value: "Poor",
  },
];

export const optionsItinerary = [
  {
    label: "None",
    value: "None",
  },
  {
    label: "TVSC Recommended Itinerary",
    value: "TVSC Recommended Itinerary",
  },
];

export const optionsBucketWiseLoadBalancing = [
  {
    label: YES_NO.YES,
    value: YES_NO.YES,
  },
  {
    label: YES_NO.NO,
    value: YES_NO.NO,
  },
];

export const optionsAllocationStatus = [
  {
    label: "Unallocated",
    value: "Unallocated",
  },
  {
    label: "Allocated",
    value: "Allocated",
  },
  {
    label: "Reallocated",
    value: "Reallocated",
  },
  {
    label: "Allocation Hold",
    value: "Allocation Hold",
  },
  {
    label: "Reallocation Hold",
    value: "Reallocation Hold",
  },
  {
    label: "Allocation Release",
    value: "Allocation Release",
  },
  {
    label: "Reallocation Release",
    value: "Reallocation Release",
  },
];
